<template>
  <!-- INSURER PARTNER (drop-down): for Super Admins -->
  <div v-if="isShowInsurance">
    <div class="row">
      <div class="col-3">
        <div class="input-group">
          <span class="input-group-text">Insurer:</span>
          <select class="form-select" v-model="selected" @change="insurerChanged">
            <option v-for="insurer in insurers" :key="insurer.firm" :value="insurer.firm">
              {{ insurer.firmName }}
            </option>
          </select>
        </div>
      </div>
      <div class="col"></div>
    </div>
  </div>
  <!-- DASHBOARD PAGE -->
  <div v-if="isSelected || !isSuperAdmin" id="mainContainer" class="main-container">
    <!-- DASHBOARD: Filter / Data Bar -->
    <div v-if="dashboardFilters" class="w-100 custom-header">
      <!-- Dates and Refresh do nothing on the Upload PDF tab, so it gets no filter bar. -->
      <ZFilterHeader v-if="!['VIN Search', 'Upload PDF'].includes(currentTab)" :id="cntId" ref="filterHeader" title="" :isDateRange="true"
        :isFilter="!isProvider" :filters="dashboardFilters" :restriction="dateRestriction" @filter="filtered"
        @datesChanged="datesChanged" @refresh="refresh" />
    </div>
    <!-- DASHBOARD: Tabs (Top Stats, Locations, VIN Search) -->
    <div class="w100 px-md-5 pt-md-3 pb-md-2 px-2 py-2">
      <ZTabs v-model="currentTab" :tabs="tabs" @change="switchTab" />
    </div>
    <!-- DASHBOARD TAB (selected) -->
    <div v-if="isFetching" class="main-content px-md-5 pt-md-2 pb-md-4 py-2">
      <span>loading...</span>
    </div>
    <div v-else class="main-content px-md-5 pt-md-2 pb-md-4 py-2">
      <!-- DASHBOARD TAB: Top Stats or Locations -->
      <!-- NOTE: the only Dashboard Name that is functional at this time is "RepairNetwork" -->
      <RepairNetwork :tab="currentTab" @view="viewLocation"></RepairNetwork>
      <!-- Issue 622 (5e): Upload PDF tab -->
      <div v-if="currentTab === 'Upload PDF' && tabs.includes('Upload PDF')">
        <UploadEstimateView />
      </div>
      <!-- DASHBOARD TAB: VIN Search -->
      <div v-if="currentTab === 'VIN Search'">
        <div class="row mt-4">
          <div class="col-5">
            <p>Use this VIN Search facility to look for a vehicle within your network.</p>
            <!-- VIN Search tool -->
            <div class="input-group custom-vin-search">
              <input class="form-control custom-vin-input" type="text" v-model="vin" maxlength="17"
                placeholder="enter or paste VIN # here" @keyup="vinKeyupHandler" />
              <span class="input-group-text custom-clear" title="clear VIN" @click="clearVINSearch">
                <i class="fas fa-times"></i>
              </span>
              <button class="btn btn-primary btn-sm" :disabled="isSearching" @click="searchVIN">
                <FontAwesomeIcon v-if="isSearching" icon="fa-solid fa-spinner" spin />
                <FontAwesomeIcon v-else icon="fa-solid fa-search" />
                <span class="ms-2">Search</span>
              </button>
            </div>
          </div>
          <div class="col">
            <div class="custom-insurance">
              <span v-if="isProviderInsuranceSearch">{{ insuranceCompany }}</span>
            </div>
          </div>
        </div>
        <div v-if="!isProviderInsuranceSearch" class="row mt-2">
          <div class="col">
            <!-- VIN Search Results -->
            <z-table v-if="vinSearchResults && vinSearchResults.length > 0" v-model="vinSearchResults"
              class="table table-bordered table-striped" :is-single-row-detail="false" :loading="isSearching">
              <template #tbody="props">
                <td>
                  <div class="row">
                    <!-- VIN Search found location -->
                    <div class="col">
                      <div class="custom-search-result">
                        <span class="custom-location" @click="gotoLocation(props.row)">{{ props.row.firmName }}</span>
                        <div class="row">
                          <div class="col"><span class="custom-vehicle">{{ props.row.vin }}</span></div>
                          <div class="col"><span class="custom-vehicle">{{ props.row.insuranceName }}</span></div>
                        </div>
                        <div class="row">
                          <div class="col"><span class="custom-vehicle">{{ formatVehicle(props.row) }}</span></div>
                        </div>
                        <div class="row">
                          <div class="col"><span class="custom-count"># repair lines: {{ props.row.repairLineCount
                          }}</span></div>
                        </div>


                      </div>
                    </div>
                    <!-- VIN Search found inspections -->
                    <div
                      v-if="isProviderInsuranceSearch || (props.row.inspections === undefined || props.row.inspections === null)"
                      class="col">

                    </div>
                    <div v-else class="col">
                      <inspection-list :row="props.row" @view="gotoInspection" />
                    </div>
                  </div>
                </td>
              </template>
              <template #empty> Nothing found! </template>
            </z-table>
            <div v-else-if="isFinished">
              <p>No results found.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import router from '@/router'
import { authStore } from '@/stores/auth'
import { locationStore } from '@/stores/location'
import { dashboardStore } from '@/stores/dashboard'
import UploadEstimateView from '@/views/UploadEstimateView.vue'
import ZFilterHeader from '@/components/utilities/elements/FilterHeader.vue'
import ZTabs from '@/components/utilities/elements/Tabs.vue'
import ZTable from '@/components/utilities/elements/Table.vue'
import CalibrationCenter from '@/components/dashboard/calibration/CalibrationCenter.vue'
import RepairNetwork from '@/components/dashboard/repairNetwork/RepairNetwork.vue'
import Shop from '@/components/dashboard/shop/Shop.vue'
import InspectionList from './elements/InspectionList.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { set } from 'lodash'
export default {
  name: 'DashboardHost',
  components: {
    UploadEstimateView,
    ZFilterHeader,
    ZTabs,
    ZTable,
    CalibrationCenter,
    RepairNetwork,
    Shop,
    InspectionList,
    FontAwesomeIcon
  },
  data() {
    return {
      isLoading: false,
      isSearching: false,
      isFinished: false,
      cntId: 0
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    ...mapState(authStore, ['profile', 'dashboardName']),
    ...mapState(locationStore, ['insurers', 'membersForExport']),
    ...mapState(dashboardStore, [
      'dashboardTab',
      'selectedCorp',
      'selectedInsurer',
      'startDate',
      'endDate',
      'dashboardFilters',
      'vinSearchResults',
      'vinSearchTerm',
      'isFetching',
      'isRefresh',
      'tableDetails',
      'selectedInsurerClass'
    ]),
    tabs() {
      let _tabs = ['VIN Search']
      if (this.isHierarchyAdmin) {
        _tabs.push('Top Stats')
      }
      if ((this.isInsurer && this.isAdmin) || this.isSuperAdmin) {
        _tabs.push('Locations')
      }
      // Issue 622 (5e): upload a PDF estimate on behalf of a customer, from the Validation Platform.
      // Same gate as the /upload-estimate route (role + PdfUpload feature).
      if (this.isAllowed('/upload-estimate')) {
        _tabs.push('Upload PDF')
      }
      return _tabs
    },
    isHierarchyAdmin() {
      // #464: every *Admin role across the firm-type hierarchy
      // (Super / Solution / Corporate / Region / Division / Branch / Team / Agent)
      return [1, 2, 3, 5, 7, 9, 12, 15].includes(this.profile.roles[0])
    },
    vin: {
      get() {
        return this.vinSearchTerm
      },
      set(value) {
        this.setVinSearchTerm(value)
      }
    },
    currentTab: {
      get() {
        return this.dashboardTab
      },
      set(value) {
        this.setTab(value)
      }
    },
    isSelected() {
      let _is = false
      if (this.selectedInsurer) {
        _is = true
      }
      return _is
    },
    selected: {
      get() {
        return this.selectedCorp
      },
      set(value) {
        this.setInsurer(value)
      }
    },
    isSuperAdmin() {
      let _is = false
      if ([1].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    },
    isAdmin() {
      let _is = false
      if ([2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    },
    isInsurer() {
      let _is = false
      if ([1].includes(this.profile.connectClass)) {
        _is = true
      }
      return _is
    },
    isProvider() {
      let _is = false
      if ([2, 3].includes(this.profile.connectClass)) {
        _is = true
      }
      return _is
    },
    isShowInsurance() {
      let _is = false
      if (this.isSuperAdmin) {
        _is = true
      } else if (this.profile.insuranceCount > 0 || this.isProviderInsuranceSearch) {
        _is = true
      }
      return _is
    },
    dateRestriction() {
      let _restriction = 1 // 3 days
      if (this.isHierarchyAdmin) {
        _restriction = 365
      }
      return _restriction
    },
    isProviderInsuranceSearch() {
      let _is = false
      if (this.isProvider && this.selectedInsurerClass === 1) {
        _is = true
      }
      return _is
    },
    insuranceCompany() {
      let _company = null
      if (this.vinSearchResults && this.vinSearchResults.length > 0) {
        if (this.vinSearchResults[0].inspections && this.vinSearchResults[0].inspections.length > 0) {
          _company = this.vinSearchResults[0].inspections[0].insuranceName
        }
      }
      return _company
    }
  },
  methods: {
    ...mapActions(authStore, ['isAllowed']),
    ...mapActions(locationStore, ['getInsurers', 'getMembersForExport']),
    ...mapActions(dashboardStore, [
      'getFirmSettings',
      'getTableData',
      'getCardData',
      'getTotals',
      'getGraphData',
      'applyFilters',
      'setInsurer',
      'searchByVin',
      'setFirm',
      'setRefresh',
      'setGridParam',
      'setTab',
      'resetDates',
      'resetVinSearch',
      'setVinSearchTerm',
      'getInsurerDashboard',
      'getProviderDashboard'
    ]),
    async init() {
      if (this.isSuperAdmin) {
        await this.getInsurers(this.profile.firm)
        if (this.insurers && this.insurers.length > 0) {
          this.setInsurer(this.insurers[0].firm)
        }
        if (this.selectedInsurer !== null && this.currentTab === 'Top Stats') {
          await this.refresh()
        }
      } else if (this.currentTab === 'Top Stats' && this.isProvider) {
        await this.getProviderDashboard({
          firm: this.profile.firm,
          startDate: this.startDate,
          endDate: this.endDate,
          status: '90'
        })
      } else if (this.currentTab === 'Top Stats' && this.isHierarchyAdmin) {
        // Insurer-side hierarchy admin (FirmClass=1) or unclassified — use the
        // insurer-data path. RepairNetwork.vue's !isProvider branch renders the
        // insurer view (Top Shops/Makes/Estimators + Total Inspections).
        this.setInsurer(this.profile.firmId)
        await this.getInsurerDashboard(this.profile.firmId)
      } else if (this.isShowInsurance) {
        await this.getInsurers(this.profile.firm)
        if (this.isProvider) {
          this.setInsurer(this.profile.firmId)
        } else if (this.insurers && this.insurers.length > 0) {
          this.setInsurer(this.insurers[0].firm)
        }
      } else {
        this.setInsurer(this.profile.firmId)
      }
      this.clearVINSearch()
      console.log('Dashboard Host Init', {
        profile: this.profile,
        dashboardName: this.dashboardName,
        selectedInsurer: this.selectedInsurer,
        insuranceClass: this.selectedInsurerClass
      })
    },
    async switchTab(tab) {
      console.log('Switching Tab', {
        tab: tab,
        isProvider: this.isProvider,
        profile: this.profile
      })
      this.resetDates()
      this.setTab(tab)
      if (this.isProvider) {
        this.setInsurer(this.profile.firmId)
      } else if (this.insurers && this.insurers.length > 0) {
        this.setInsurer(this.insurers[0].firm)
      }
      console.log('Switch Tab', {
        tab: tab,
        provider: this.isProvider,
        profile: this.profile
      })
      if (tab === 'VIN Search') {
        this.clearVINSearch()
      } else {
        this.refresh(true)
      }
    },
    datesChanged(data) {
      console.log('Dates Changed', data)
      this.cntId++
      this.$forceUpdate()
    },
    async refresh(forceRefresh = false) {
      if (this.currentTab === 'Top Stats' && this.isProvider) {
        console.log('Refresh for Provider Dashboard')
        await this.getProviderDashboard({
          firm: this.profile.firm,
          startDate: this.startDate,
          endDate: this.endDate,
          status: '90'
        })
      } else if (this.currentTab === 'Top Stats' && this.isHierarchyAdmin && !this.isSuperAdmin) {
        // Insurer-side hierarchy admin — fire the insurer-data path.
        this.setInsurer(this.profile.firmId)
        await this.getInsurerDashboard(this.profile.firmId)
      } else {
        if (forceRefresh || this.tableDetails === null) {
          this.setRefresh(true)
        }
        if (this.isRefresh) {
          this.setGridParam({
            name: 'page',
            value: 1
          })
          setTimeout(async () => {
            console.log('Refresh for Insurer', this.selectedCorp)
            if (this.selectedCorp !== null && this.currentTab === 'Top Stats') {
              await this.getInsurerDashboard(this.selectedCorp)
            } else if (this.currentTab === 'Locations') {
            }
            this.setRefresh(false)
          }, 500)
        }
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },
    filtered(filters) {
      this.applyFilters(filters)
    },
    async insurerChanged() {
      this.clearVINSearch()
      if (this.currentTab !== 'VIN Search') {
        await this.refresh()
      }
      this.isSelected = true
    },
    viewLocation(firm) {
      console.log('View Location', firm)
    },
    vinKeyupHandler() {
      console.log('VIN Keyup')
    },
    clearVINSearch() {
      this.isSearching = false
      this.isFinished = false
      this.vin = null
      this.resetVinSearch()
    },
    async searchVIN() {
      console.log('Search VIN', this.vin)
      this.isSearching = true
      this.isFinished = false
      if (this.vin !== null) {
        await this.searchByVin(this.vin)
      }
      this.isSearching = false
      this.isFinished = true
    },
    async gotoLocation(row) {
      let proceed = true
      if (this.isProviderInsuranceSearch) {
        proceed = false
        // check to see if Provider has this firm in their membership
        await this.getMembersForExport({
          firm: this.selectedInsurer,
          type: 99,
          filter: 'root'
        })
        // check if the firm exists in the members list
        let member = this.membersForExport.find((m) => parseInt(m.id) === parseInt(this.selectedInsurer))
        if (member) {
          proceed = true
        }
      }
      if (proceed) {
        this.setGridParam({
          name: 'page',
          value: 1
        })
        this.setFirm({
          firm: row.firm,
          name: row.firmName,
          source: row.source,
          inspections: row.inspections?.length,
          address: null,
          addressLines: null,
          servicesCompleted: 0,
          servicesRequired: 0,
          vin: row.vin
        })
        this.setGridParam({
          name: 'searchTerm',
          value: row.vin
        })
        router.push(`/repairNetwork/${row.firm}`)
      }
    },
    gotoInspection(row, inspection) {
      console.log('Goto Inspection', {
        row: row,
        inspection: inspection
      })
      this.setFirm({
        firm: row.firm,
        name: row.firmName,
        source: row.source
      })
      router.push(`/vehicle-details/${row.vin}/${inspection}/vinsearch`)
    },
    formatVehicle(row) {
      console.log('Format Vehicle', row)
      return `${row.year} ${row.make} ${row.model}`
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  height: 48px;
}

.filter-and-mobile-togler {
  background: #fff;
}

.custom-search-result {
  display: flex;
  flex-direction: column;
}

.custom-location {
  font-size: 1.3rem;
  font-weight: 600;
  padding: 10px;
}

.custom-location:hover {
  cursor: pointer;
  background-color: #fffeb7;
}

.custom-vehicle {
  font-size: 1.1rem;
  font-weight: 400;
}

.custom-count {
  font-size: 0.9rem;
  font-weight: 400;
}

.custom-vin-search {
  margin-top: 15px;
  border: 2px solid #ff0000;
  padding: 15px;
}

.custom-vin-input {
  font-size: 1.3rem !important;
  font-weight: 600 !important;
}

.custom-insurance {
  font-size: 1.3rem;
  font-weight: 600;
  color: #000;
  margin-top: 60px;
}
</style>
